import { reducerWithInitialState } from 'typescript-fsa-reducers';
import { priceSumAction } from '@app/react/action';

export interface IPriceSumReducer {
    price: number;
}

const initState: IPriceSumReducer = {
    price: 0,
};

export const PriceSumReducer = reducerWithInitialState(initState)
    .case(priceSumAction, (state, action) => ({
        ...state,
        price: action.price,
    }));
